// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"eff106af","977":"756f3419"}[chunkId] + ".chunk.js";
};